const popUp = {};

Element.prototype.appendAfter = function (element) {
    element.parentNode.insertBefore(this,element.nextSibling);
}

function nope() {}

function _createModalFooter(buttons = [] )  {
    if(buttons.length === 0) {
        return document.createElement('div');
    }
    const wrap = document.createElement('div');
    wrap.classList.add('modal-footer');
    const $buttonWrap = document.createElement('div');
    $buttonWrap.classList.add('button-wrapper');
    wrap.appendChild($buttonWrap);
    buttons.forEach(btn=>{
        const $btn = document.createElement('a');
        $btn.textContent = btn.text;
        $btn.setAttribute('href',`#`);
        $btn.href = `${btn.linkhref}`;
        $btn.classList.add('btn-default');
        $btn.classList.add(`btn-${btn.type}` || '');
        $btn.onclick = btn.handler || nope;
        $buttonWrap.appendChild($btn);
    });
    return wrap
}

function _createModal(options) {
    const default_width = '1400px';
    const modal = document.createElement('div');
    modal.classList.add('modal');
    modal.insertAdjacentHTML('afterbegin',`
    <div class="modal-overlay" data-close="true">
    <div class="modal-window" style="max-width:${options.width || default_width}">
    <div class="modal-header">
    <span class="modal-title">${options.title || 'Модальное окно'}</span>
    ${options.closeble ? `<span class="modal-close" data-close="true">&times;</span>` : ''} 
    </div>
    <div class="modal-body" data-content>
    <form>
      ${options.content || ''}
    </form>
    </div>
    </div>
    </div>`);
    const footer = _createModalFooter(options.footerButtons);
    footer.appendAfter(modal.querySelector('[data-content]'));
    document.body.appendChild(modal);
    return modal
}

popUp.modal = function (options) {
    const amimation_speed = 400;
    const $modal = _createModal(options);
    let closing = false;
    let destroyed = false;

    const modal = {
        open() {
            if(destroyed){
                return console.log('modal is destroyed');
            }

            !closing && $modal.classList.add('open');
        },
        close() {
            closing = true;
            $modal.classList.remove('open');
            $modal.classList.add('hiding');
            setTimeout(()=>{
                $modal.classList.remove('hiding');
                closing = false;
            },amimation_speed)
        },
    }

    const listener = event => {
        if(event.target.dataset.close){
            modal.close();
        }
    }

    $modal.addEventListener('click',listener);

    return Object.assign(modal,{
        destroy(){
            $modal.parentNode.removeChild($modal);
            $modal.removeEventListener('click',listener);
            destroyed = true;
        },
        setContent(html){
            $modal.querySelector('[data-content]').innerHTML = html;
        }
    })

};

const cart = popUp.modal({
    title:'Корзина',
    closeble:true,
    content:`
  <div class="cart-wrapper js-cart">
                <div class="cart-wrapper__item js-cart-item">
                    <div class="cart-info-img cart-item">
                        <div class="img">
                            <img src="assets/images/product-card/product-card-additional-3.png" alt="product img">
                        </div>
                        <div class="info">
                            <div class="title">
                                Рубашка из органического хлопка белая
                            </div>
                            <div class="articul">
                                Код: 1234567
                            </div>
                            <div class="price">
                                Цена: <span class="mark">599 грн.</span>
                            </div>
                            <div class="size">
                                Размер: <span class="mark">2XL</span>
                            </div>
                        </div>
                    </div>
                    <div class="cart-info-count d-flex flex-column cart-item">
                        <span class="d-flex mb-2">
                            Количество
                        </span>
                        <div class="quantity-block js-cart-spinner"><button type="button" class="quantity-arrow-minus js-cart-spinner__decrement">-</button> <input class="quantity-num js-cart-spinner__amount" value="20"> <button type="button" class="quantity-arrow-plus js-cart-spinner__increment">+</button></div>
                    </div>
                    <div class="cart-info-sum cart-item">
                          <span class="d-flex mb-2">
                           Сумма
                            </span>
                        <span class="price mark js-cart-total">
                            599 грн.
                        </span>
                    </div>
                    <div class="cart-info-delete cart-item js-cart-item__delete">
                        х удалить
                    </div>
                </div>
                <div class="cart-wrapper__item js-cart-item">
                    <div class="cart-info-img cart-item">
                        <div class="img">
                            <img src="assets/images/product-card/product-card-additional-3.png" alt="product img">
                        </div>
                        <div class="info">
                            <div class="title">
                                Рубашка из органического хлопка белая
                            </div>
                            <div class="articul">
                                Код: 1234567
                            </div>
                            <div class="price">
                                Цена: <span class="mark">599 грн.</span>
                            </div>
                            <div class="size">
                                Размер: <span class="mark">2XL</span>
                            </div>
                        </div>
                    </div>
                    <div class="cart-info-count d-flex flex-column cart-item">
                        <span class="d-flex mb-2">
                            Количество
                        </span>
                        <div class="quantity-block js-cart-spinner"><button type="button" class="quantity-arrow-minus js-cart-spinner__decrement">-</button> <input class="quantity-num js-cart-spinner__amount" value="20"> <button type="button" class="quantity-arrow-plus js-cart-spinner__increment">+</button></div>
                    </div>
                    <div class="cart-info-sum cart-item">
                          <span class="d-flex mb-2">
                           Сумма
                            </span>
                        <span class="price mark js-cart-total">
                            599 грн.
                        </span>
                    </div>
                    <div class="cart-info-delete cart-item js-cart-item__delete">
                        х удалить
                    </div>
                </div>
            </div>
    `,
    width:'900px',
    footerButtons:[
        {text:'Оформить заказ',linkhref:'cart-page.html', type:'', handler(){

            }},
    ]
});

document.querySelector('.js-cart-open').addEventListener('click',function () {
    cart.open();
});

document.addEventListener('click',e =>{
    const btnType = e.target.dataset.btn;
    switch(btnType){
        case 'cart':
            e.preventDefault();
            cart.open();
            break;
    }
});